import AddVehicleOwnerInfoModal from './add-vehicle-owner-info-modal.vue'
export default AddVehicleOwnerInfoModal
